import { Dispatch } from 'redux';
import { ProductLine, VoidFunc } from '@trucktrax/trucktrax-ts-common';
import { MESSAGE_SELECTED } from '../constants/appConstants';
import { setReduxDriverList } from './driversService';
import { setFeatureFlagsWithUserUrl } from './featureFlagsService';
import { changeTrackingSocketConnection, getMapview } from './mapviewsService';
import { changeMessagingSocketConnection, getInboxMessages } from './messagesService';
import { fetchPlantListAndMapFilters } from './plantsService';
import { setSelectedProductLine } from './productLinesService';
import { setCurrentRegion } from './regionsService';
import { changeTicketSocketConnection, fetchCurrentTicketList } from './ticketsService';
import { updateToFieldValue } from '../store/actions/messageActions';
import setSidebarSelected from '../store/actions/sidebarActions';
import { clearSelectedTicket, resetTicketView } from '../store/actions/ticketActions';

export const refreshGeoTraxState =
  (
    region?: { url?: string; name?: string },
    productLine?: ProductLine,
    userUrl?: string,
    messageSubscriptions?: {
      url?: string;
      unsubscribe: VoidFunc;
    }[],
    bypassCache: boolean = false,
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    if (!region?.url || !productLine) {
      return;
    }

    dispatch(setSidebarSelected(MESSAGE_SELECTED, false));
    setSelectedProductLine(productLine)(dispatch);

    if (region.name) {
      setCurrentRegion({ ...region, defaultRegion: false })(dispatch);
    }

    dispatch(clearSelectedTicket());
    dispatch(resetTicketView());
    dispatch(updateToFieldValue([]));

    getMapview(region.url)(dispatch, getState);
    fetchPlantListAndMapFilters(region.url, productLine, userUrl)(dispatch, getState);
    setReduxDriverList(region.url, [productLine], bypassCache)(dispatch);

    getInboxMessages(undefined, undefined, region, productLine)(dispatch);
    fetchCurrentTicketList(region.url, productLine)(dispatch);

    await changeMessagingSocketConnection(region, messageSubscriptions);
    await changeTicketSocketConnection(region, productLine);
    await changeTrackingSocketConnection(region.url ?? '');

    if (userUrl) {
      setFeatureFlagsWithUserUrl(userUrl, region.url);
    }
  };
